import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'riskLevel',
  standalone: false,
})
export class RiskLevelPipe implements PipeTransform {
  // todo: remove this, get from server instead

  public static riskLevels: RiskLevel[] = [
    { code: 'VH', name: 'Very High Risk', pri: 100 },
    { code: 'H', name: 'High Risk', pri: 200 },
    { code: 'M', name: 'Medium Risk', pri: 300 },
    { code: 'L', name: 'Low Risk', pri: 400 },
    { code: 'VL', name: 'Very Low Risk', pri: 500 },
    { code: 'U', name: 'Unset Risk', pri: 1000 },
  ];

  public transform(value: string): string {
    if (value) {
      for (const urgencyLevel of RiskLevelPipe.riskLevels) {
        if (urgencyLevel.code === value) {
          return urgencyLevel.name;
        }
      }
    }
    return 'Unknown Risk';
  }
}

export class RiskLevel {
  public readonly code: string;
  public readonly name: string;
  public readonly pri: number;
}
